import { z } from "zod";

export const DEFAULT_SITE_SETTINGS = {
  whatsapp_primary: "5541988692568",
  whatsapp_secondary: "5541995818424",
  email: "abillytingmarketing@gmail.com",
  whatsapp_message: "Olá! Vim pelo site da Abillyting Marketing e gostaria de saber mais sobre os serviços.",
  instagram_url: "", linkedin_url: "", youtube_url: "", facebook_url: "", twitter_url: "",
};
export type SiteSettings = typeof DEFAULT_SITE_SETTINGS;
const phone = z.string().trim().transform((value) => {
  const digits = value.replace(/\D/g, "");
  return digits.length <= 11 ? `55${digits}` : digits;
}).pipe(z.string().regex(/^55\d{10,11}$/, "Informe um telefone brasileiro com DDD."));
const url = z.string().trim().refine((value) => {
  if (!value) return true;
  try { const parsed = new URL(value); return parsed.protocol === "https:" && !!parsed.hostname && !parsed.username && !parsed.password; }
  catch { return false; }
}, "Use um endereço completo começando com https://.");
export const siteSettingsSchema = z.object({
  whatsapp_primary: phone, whatsapp_secondary: phone,
  email: z.string().trim().email("Informe um e-mail válido.").max(255),
  whatsapp_message: z.string().trim().min(1, "Informe a mensagem.").max(500),
  instagram_url: url, linkedin_url: url, youtube_url: url, facebook_url: url, twitter_url: url,
});
export const whatsappLink = (phone: string, message: string) => `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
export const displayPhone = (phone: string) => {
  const digits = phone.replace(/^55/, "");
  return `(${digits.slice(0, 2)}) ${digits.slice(2, -4)}-${digits.slice(-4)}`;
};